module.exports = __webpack_public_path__ + "img/page-18.66114f3a.jpg";